import { render } from "./modalsave.vue?vue&type=template&id=41c382a1&scoped=true"
import script from "./modalsave.vue?vue&type=script&lang=js"
export * from "./modalsave.vue?vue&type=script&lang=js"

import "./modalsave.vue?vue&type=style&index=0&id=41c382a1&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41c382a1"]])

export default __exports__